import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorHandleService } from './error-handle.service';
//TW20251010
import { OfficeLeaseBuildingGraphResponse, OfficeLeaseDetailBuildingFloorResponse, OfficeLeaseDetailResponse, OfficeLeaseDetailROResponse, OfficeLeaseOccupancyResponse, OfficeLeaseResponse, OfficeLeaseRevenueResponse, OfficeLeaseTenantListBuildingResponse, OfficeLeaseTenantResponse, OfficeLeaseActivitiesResponse } from '../models/office-lease';
//End of TW20251010
import { catchError, Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class OfficeLeaseService {

  private apiUrl = `${environment.APIDEV}`;

  constructor(
    private http: HttpClient,
    private errorHandle: ErrorHandleService
  ) { }

  getOfficeLease(
    page: number = 1,
    perPage: number = 10,
    search?: string,
    sortBy?: string,
    sortOrder?: 'ASC' | 'DESC',
    startDate?: string,
    endDate?: string
  ): Observable<OfficeLeaseResponse> {

    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());

    if (search) {
      params = params.set('search', search);
    }
    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }
    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }
    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<OfficeLeaseResponse>(`${this.apiUrl}office_lease/list`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getOfficeLeaseRevenue(
    startDate?: string,
    endDate?: string
  ): Observable<OfficeLeaseRevenueResponse> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<OfficeLeaseRevenueResponse>(`${this.apiUrl}office_lease/revenue`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getOfficeLeaseTenantList(
    startDate?: string,
    endDate?: string
  ): Observable<OfficeLeaseRevenueResponse> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<OfficeLeaseRevenueResponse>(`${this.apiUrl}office_lease/tenants`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getOfficeLeaseOccupancy(
    startDate?: string,
    endDate?: string
  ): Observable<OfficeLeaseOccupancyResponse> {
    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<OfficeLeaseOccupancyResponse>(`${this.apiUrl}office_lease/occupancy`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getOfficeLeaseDetail(
    id: number,
    startDate?: string,
    endDate?: string
  ): Observable<OfficeLeaseDetailResponse> {

    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<OfficeLeaseDetailResponse>(`${this.apiUrl}office_lease/detail/${id}`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getOfficeLeaseDetaiRO(
    id: number,
    startDate?: string,
    endDate?: string
  ): Observable<OfficeLeaseDetailROResponse> {

    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<OfficeLeaseDetailROResponse>(`${this.apiUrl}office_lease/detail/${id}/revenue_occupancy_rate`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getOfficeLeaseDetailBuildingFloor(
    id: string | number,
    page: number = 1,
    perPage: number = 10,
    search?: string,
    sortBy?: string,
    sortOrder?: string,
    startDate?: string,
    endDate?: string
  ): Observable<OfficeLeaseDetailBuildingFloorResponse> {

    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());
    if (search) {
      params = params.set('search', search);
    }

    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }

    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<OfficeLeaseDetailBuildingFloorResponse>(`${this.apiUrl}office_lease/detail/${id}/building_floor`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  //TW20251010
  getOfficeLeaseBuildingGraph(
    id: string | number,
    startDate?: string,
    endDate?: string
  ): Observable<OfficeLeaseBuildingGraphResponse> {

    let params = new HttpParams();
    

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<OfficeLeaseBuildingGraphResponse>(`${this.apiUrl}office_lease/${id}/building_graph`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }
  //END OF TW20251010
  
  getOfficeLeaseTenant(
    startDate?: string,
    endDate?: string
  ): Observable<OfficeLeaseTenantResponse> {

    let params = new HttpParams()

    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<OfficeLeaseTenantResponse>(`${this.apiUrl}office_lease/tenants/overview`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }


  getOfficeLeaseTenanListBuilding(
    id: string | number,
    page: number = 1,
    perPage: number = 10,
    search?: string,
    sortBy?: string,
    sortOrder?: string,
    startDate?: string,
    endDate?: string
  ): Observable<OfficeLeaseTenantListBuildingResponse> {
    // Initialize HttpParams
    let params = new HttpParams()
      .set('page', page.toString())
      .set('perPage', perPage.toString());

    // Add optional parameters if they exist
    if (search) {
      params = params.set('search', search);
    }

    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }

    if (sortOrder) {
      params = params.set('sortOrder', sortOrder);
    }

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    // Fix: Remove template literals in the URL path
    return this.http.get<OfficeLeaseTenantListBuildingResponse>(
      `${this.apiUrl}/office-lease/tenant/detail-tenant/${id}/list-building`,
      {
        params,
        ...this.errorHandle._httpOptions()
      }
    ).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getOfficeLeaseSalesActivities(
      startDate?: string,
      endDate?: string,
      filter?: string
    ): Observable<OfficeLeaseActivitiesResponse> {
  
      let params = new HttpParams();
  
      if (startDate) {
        params = params.set('startDate', startDate);
      }
  
      if (endDate) {
        params = params.set('endDate', endDate);
      }
  
      if (filter) {
        params = params.set('filter', filter);
      }
  
      return this.http.get<OfficeLeaseActivitiesResponse>(`${this.apiUrl}overview/sales_activities`, {
        params,
        ...this.errorHandle._httpOptions()
      }).pipe(
        catchError(this.errorHandle.errorHandl)
      );
    }

}
